import { useState } from 'react'
import type { UserBrief } from '../../types'
import { mediaUrl } from '../../utils/mediaUrl'

const SIZES = { sm: 'h-9 w-9 text-sm', md: 'h-12 w-12 text-base' }

/** The creator's photo, or their initial on an accent tint when there's none (or it fails). */
const CreatorAvatar = ({ user, size = 'md' }: { user?: UserBrief | null; size?: 'sm' | 'md' }) => {
  const [broken, setBroken] = useState(false)
  const name = user?.full_name || user?.username || ''
  if (user?.avatar_url && !broken) {
    return (
      <img
        src={mediaUrl(user.avatar_url)}
        alt=""
        onError={() => setBroken(true)}
        className={`${SIZES[size]} flex-shrink-0 rounded-full object-cover ring-1 ring-white/10`}
      />
    )
  }
  return (
    <div
      aria-hidden="true"
      className={`${SIZES[size]} flex-shrink-0 rounded-full bg-accent/15 text-accent font-semibold flex items-center justify-center`}
    >
      {name.charAt(0).toUpperCase() || '?'}
    </div>
  )
}

export default CreatorAvatar
